import { render } from "./VersionHistoryTab.vue?vue&type=template&id=b3cb85c6"
import script from "./VersionHistoryTab.vue?vue&type=script&lang=js"
export * from "./VersionHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__